<template>
    <div class="request-box" :class="theme" v-show="show">
        <div class="mg-container">
            <button @click="RequestPop">
                {{ buttonText || $t('md-sold-detail.requestAFreeAnalysis') }}
            </button>
        </div>
    </div>
</template>

<script>
import popMgr from '@/components/global/popMgr';
import RequestPop from './est-request-pop.vue';
import global from '@/common/global';
import { mapState } from 'pinia';
import { useUserStore } from "@/store";

import signLog from '@/components/sign-log';
export default {
    i18next: {
        ns: 'md-sold-detail'
    },
    props: {
        buttonText: {
            type: String
        },
        theme: {
            type: String,
            default: 'classic'
        },
        submitText: {
            type: String,
            default: null
        },
        scroll: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            show: true
        };
    },
    computed: {
        ...mapState(useUserStore, {
            user: store => store.user
        })
    },
    unmounted() {
        global.scroll(this.onScroll, true);
    },
    mounted() {
        if (this.scroll) {
            global.scroll(this.onScroll); 
        }
    },
    methods: {
        RequestPop() {
            if (this.user && this.user.loginStatus !== -1) {
                popMgr.create(RequestPop, {
                    _storeName: this._storeName,
                    theme: this.theme,
                    submitText: this.submitText
                });
            } else {
                signLog.register(
                    {
                        registerTitle: null,
                        submitRegister: this.submitText
                    },
                    'evaluationRegister'
                );
            }
        },
        onScroll() {
            let moduleData = this.$root.moduleData;
            let last = moduleData[moduleData.length - 1];
            //  when swiping to the bottom ， to hide the button ， Otherwise something that would obscure the last module
            if (last?.vm?.$el) {
                let lastElem = last.vm.$el;
                let lastRect = lastElem.getBoundingClientRect();
                if (lastRect.bottom - 20 <= window.innerHeight) {
                    this.show = false;
                } else {
                    this.show = true;
                }
            }
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.request-box {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 60px;
    padding: 10px 0;
    z-index: 2;
    background-color: #fff;
    button {
        padding: 10px;
        font-size: 16px;
        font-family: var(--font-bold);
        width: 100%;
        @include ellipsis();
        @include color-button();
    }
    &.classic {
        box-shadow: 0 -4px 10px 0 rgba(0, 0, 0, 0.1);
    }
    &.standard {
        box-shadow: 0 -4px 10px 3px rgba(170, 186, 218, 0.3);
    }
    &.broker {
        box-shadow: 0 -4px 10px 3px rgba(0, 10, 30, 0.05);
        z-index: var(--level-sublow);
        button {
            border-radius: 20px;
        }
    }
}
</style>
